
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import MarketAssetList from '../../components/MarketAssetList';
import Page from '../../components/Page';
import getServerSideProps from '../../utils/serverProps';
export default function Market({ hasError }) {
    const { t } = useTranslation();
    return (<Page hasError={hasError} title={t('navigation.marketplace')}>
      <MarketAssetList />
    </Page>);
}
export {};

    async function __Next_Translate__getServerSideProps__1a0f35fc4f7__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[shortName]/market',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0f35fc4f7__ as getServerSideProps }
  